import * as Yup from 'yup'

const productSchema = Yup.object().shape({
  sku: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('Required'),
  name: Yup.string().min(2, 'Too Short!').required('Required'),
  product_detail: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
  link: Yup.string().required('Required'),
  transaction_value: Yup.number().required('Required'),
  point: Yup.number().required('Required'),
  parcent: Yup.number().required('Required'),
})

export default productSchema
